<div *ngIf="category">
  <div class="stick-top">
    <mat-toolbar>
      <mat-icon>category</mat-icon> {{!category.id ? 'Create Access Category' : ('Access Category: ' + category.name)}}
    </mat-toolbar>
    <div class="hbox lightly-padded button-bar">
      <button mat-raised-button class="primary" type="button" (click)="save()" [disabled]="!form.form.valid">
        <mat-icon>{{!category.id ? 'add' : 'save'}}</mat-icon>
        {{(category.id ? 'Update ' : 'Add ')}}
      </button>
      <micro-delete-confirm *ngIf="category.id" (onConfirm)="delete()" [disabled]="category.id === 'default'"></micro-delete-confirm>
    </div>
  </div>

  <div class="padded">
    <form #form="ngForm" role="form" class="vbox">
      <table class="basicTable vtable">
        <thead>
        <tr>
          <th colspan="100">Access Category</th>
        </tr>
        </thead>
        <tbody>
        <tr>
          <th><micro-valid-label for="shortCode" [model]="shortCode" label="Short Code"></micro-valid-label></th>
          <td><input #shortCode="ngModel" [(ngModel)]="category.shortCode" required [disabled]="category.id === 'default'" id="shortCode" name="shortCode" maxlength="20"></td>
        </tr>
        <tr>
          <th><micro-valid-label for="name" [model]="name" label="Name"></micro-valid-label></th>
          <td><input #name="ngModel" [(ngModel)]="category.name" required id="name" name="name" maxlength="50"></td>
        </tr>
        <tr>
          <th><micro-valid-label for="description" [model]="description" label="Description"></micro-valid-label></th>
          <td style="width: 600px"><input #description="ngModel" [(ngModel)]="category.description" id="description" name="description" maxlength="1024"></td>
        </tr>
        <tr>
          <td *ngIf="category.id !== 'default'" colspan="2">
            <micro-picklist *ngIf="saUsers"
                            [all]="saUsers"
                            [(selectedIds)]="category.userIds"
                            displayField="plDisplayName"
                            [title]="'Users with ' + (category.shortCode ?? '') + ' access'"
                            [availableLabel]="'Unassigned Users (Department/User)'"
                            [selectedLabel]="'Assigned Users (Department/User)'">

            </micro-picklist>
          </td>
        </tr>
        <tr>
          <td colspan="2">
            <micro-picklist *ngIf="locks"
                            [all]="locks"
                            [(selectedIds)]="category.lockIds"
                            displayField="plDisplayName"
                            [title]="'Locks with ' + (category.shortCode ?? '') + ' access'"
                            [availableLabel]="'Unassigned Locks (Region.Site.Lock)'"
                            [selectedLabel]="'Assigned Locks (Region.Site.Lock)'">
            </micro-picklist>
          </td>
        </tr>
        </tbody>
      </table>

    </form>
  </div>
</div>


